import { openSection } from './psec.ts';
import { initSelectPop } from './selectpop.ts';
import { showLoud } from './loudspeaker.ts';
import { setPassLaunch } from '../shared/pass.ts';
import { attributionField } from './attribution.ts';
import { maybeShowNews } from './whatsnew.ts';
import { onPrices } from './pages.ts';
import { Net } from './net.ts';
import { S } from './state.ts';
import { loadManifest, watchCreaturePortraits, watchArtIcons } from './assets.ts';
import { mountField, fieldEvents, resetBackground } from './field.ts';
import { mountGame, render, renderFeed, toast, bindSend, refreshModal, openTab } from './ui.ts';
import { initStore, onGemBal, purchaseCredited } from './store.ts';
import { checkAccountOnHello } from './account-settings.ts';
import { dropToasts } from './dialog.ts';
import { onPlayerReport } from './player-report.ts';
import { hudEvents, startHudClock } from './hud.ts';
import { tutorialEvents } from './tutorial.ts';
import { watchEvents } from './watch.ts';
import { cornerEvents, onCornerChange, cornerOpen, cornerAuraChime } from './corner/index.ts';
import { bindGolden, goldenEvents, onGolden } from './golden.ts';
import { bindConnection, onConnection, startStatusClock } from './status.ts';
import { SYNERGY_SWITCH } from '../shared/synergy.ts';
import { BOARD_SWITCH } from '../shared/pvpfight.ts';
import { SPECIES, DEX_SPECIES } from '../shared/species.ts';
import { CONFIG } from '../shared/config.ts';
import { ITEM, relicGrade, relicName } from '../shared/items.ts';
import { GROUND, AREA } from '../shared/grounds.ts';
import { esc } from './fmt.ts';
import { signupEmailShapeProblem } from '../shared/signup-domains.ts';
import { awayEvents, awayFromServer } from './away.ts';
import { onRecords, onBoards, loadCommunity } from './community.ts';
import { onCreatureView } from './peek.ts';
import { route } from './router.ts';
import { onGuildView, onGuildList, onGuildChanged, onGuildWar, onGuildWarLog, onGuildWarResult, loadGuild } from './guild.ts';
import { onArena, onArenaResult, onArenaMatch, onArenaPeek, loadArena } from './arena.ts';
import { onHalls, onHallDuel, onHallResult, loadHalls } from './halls.ts';
import { onWb, onWbResult, loadWorldBoss, worldBossErr } from './worldboss.ts';
import { onHallPractice, loadPlan } from './plan.ts';
import { onTour, onTourMatch, onTourGame, loadTournaments } from './tournaments.ts';
import { onInbox } from './messages.ts';
import { openChatRoute, gemPaying } from './ui.ts';
import { onSocial, onProfile, onPmThread, onPmNew, onSocialNote, onFriendlyResult, onFriendlyMatch, openSocialRoute } from './social.ts';
import { onTraining } from './training.ts';
import { setEvents } from './events.ts';
import { onStreams } from './streams.ts';
import { authExtras, bindAuthExtras, handleAuthLinks, loadAuthConfig } from './account.ts';
import type { CreatureDTO, FieldDTO, GameEvent } from '../shared/protocol.ts';
import { setSampleAdmin } from './sample.ts';
import { showElsewhere, hideElsewhere } from './elsewhere.ts';
import { onKinhall, onKinhallEmote, kinhallReconnected } from './kinhall.ts';
import { onWayfarers, onWayfarerEmote, wayfarersReconnected } from './wayfarers.ts';
import { HELD_SWITCH, heldName } from '../shared/held.ts';
import { onTrailFight, trailBossShown } from './trail.ts';
import { applyTrainerPatch, type TrainerPatch } from '../shared/trainer-patch.ts';
import { applyFieldPatch, type FieldPatch } from '../shared/field-patch.ts';

const app = document.getElementById('app')!;

function authScreen(mode: 'login' | 'register' = 'register', startErr = '') {
  const extra = authExtras();
  const embers = Array.from({ length: 14 }, (_, i) => `<i style="--x:${(i * 37) % 100}%;--d:${6 + (i * 7) % 6}s;--w:${-(i * 1.3).toFixed(1)}s"></i>`).join('');
  app.innerHTML = `<main class="landing">
    <div class="embers" aria-hidden="true">${embers}</div>
    <section class="pitch">
      <div class="hero" role="img" aria-label="A phoenix"><div class="glow"></div><div class="beast"></div></div>
      <h1>Legendkin</h1>
      <p class="tag">Every legend can be caught.</p>
    </section>
    <div class="auth">
      <div class="modes" role="tablist">
        <button type="button" role="tab" data-m="register">New trainer</button>
        <button type="button" role="tab" data-m="login">Log in</button>
      </div>
      <form id="auth">
        <input name="email" type="email" placeholder="Email" autocomplete="email" required aria-label="Email">
        <input name="password" type="password" placeholder="Password" minlength="8" required aria-label="Password">
        <input name="confirm" type="password" placeholder="Confirm password" autocomplete="new-password" required aria-label="Confirm password">
        <div class="err" id="autherr" role="alert"></div>
        <button class="btn primary"></button>
        ${extra.forgot}
        ${extra.providers}
      </form>
      <nav class="legal"></nav>
    </div>
  </main>`;
  const form = document.getElementById('auth') as HTMLFormElement;
  const pass = form.elements.namedItem('password') as HTMLInputElement;
  const email = form.elements.namedItem('email') as HTMLInputElement;
  const confirm = form.elements.namedItem('confirm') as HTMLInputElement;
  const legal = app.querySelector<HTMLElement>('.auth .legal')!;
  const terms = '<a href="/terms">Terms</a>', privacy = '<a href="/privacy">Privacy</a>';
  const MISMATCH = "Passwords don't match.";
  const mismatch = () => mode === 'register' && !!confirm.value && confirm.value !== pass.value;
  // Say so once the second box is left, and clear it the moment the two agree.
  confirm.onblur = () => { if (mismatch()) err.textContent = MISMATCH; };
  pass.oninput = confirm.oninput = () => { if (err.textContent === MISMATCH && !mismatch()) err.textContent = ''; };
  // New accounts take only the big providers; say so as soon as the field is left, not after submitting.
  email.onblur = () => { if (mode === 'register' && email.value.includes('@')) err.textContent = signupEmailShapeProblem(email.value) ?? ''; };
  const err = document.getElementById('autherr')!;
  const setMode = (m: typeof mode) => {
    mode = m;
    for (const b of app.querySelectorAll<HTMLButtonElement>('.modes button')) b.setAttribute('aria-selected', String(b.dataset.m === m));
    pass.autocomplete = m === 'register' ? 'new-password' : 'current-password';
    pass.minLength = m === 'register' ? 8 : 0;
    // Disabled keeps it out of the form data and of the browser's required check on Log in.
    confirm.hidden = confirm.disabled = m !== 'register';
    legal.innerHTML = m === 'register' ? `By starting you accept the ${terms} and ${privacy} and are 13+.` : `${terms} · ${privacy}`;
    form.querySelector('button')!.textContent = m === 'register' ? 'Start your hunt' : 'Log in';
    err.textContent = '';
    const forgot = document.getElementById('forgot');
    if (forgot) forgot.hidden = m !== 'login';
  };
  for (const b of app.querySelectorAll<HTMLButtonElement>('.modes button')) b.onclick = () => setMode(b.dataset.m as typeof mode);
  setMode(mode);
  err.textContent = startErr;
  bindAuthExtras(app, () => authScreen('login'));
  form.onsubmit = async (e) => {
    e.preventDefault();
    const bad = mode === 'register' ? signupEmailShapeProblem(email.value) : null;
    if (bad) { err.textContent = bad; email.focus(); return; }
    if (mode === 'register' && confirm.value !== pass.value) { err.textContent = MISMATCH; confirm.focus(); confirm.select(); return; }
    const res = await fetch(`/api/${mode}`, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ ...Object.fromEntries([...new FormData(form)].filter(([k]) => k !== 'confirm')), ...(mode === 'register' ? { attr: attributionField() } : {}) }) });
    const data = await res.json();
    if (!res.ok) { err.textContent = data.error ?? 'Something went wrong.'; return; }
    localStorage.setItem('mi-token', data.token);
    start(data.token);
  };
}

let lastRender = 0;
let pendingRender = false;
function scheduleRender() {
  // A hidden tab keeps the state current but skips the DOM; it catches up on return.
  if (pendingRender || document.hidden) return;
  pendingRender = true;
  const wait = Math.max(0, 250 - (performance.now() - lastRender));
  setTimeout(() => { pendingRender = false; lastRender = performance.now(); render(); }, wait);
}

function applyEvents(evs: GameEvent[]) {
  awayEvents(evs);
  watchEvents(evs);
  fieldEvents(evs);
  hudEvents(evs);
  tutorialEvents(evs);
  cornerEvents(evs);
  goldenEvents(evs, { auraChime: cornerAuraChime() });
  let modal = false;
  for (const e of evs) {
    if (e.k === 'catch') {
      if (e.sold) continue;
      S.creatures.set(e.creature.id, e.creature);
      const sp = SPECIES[e.creature.species];
      // Ordinary catches go to the combat log; only the exciting ones get a toast.
      if (e.creature.rolls.aura || e.creature.rolls.bloodline >= 3) toast(`${e.creature.rolls.aura ? 'Aura ' : ''}${sp.name} caught! Lv ${e.creature.level}`, 'gold');
      else if ((S.trainer?.dex[e.creature.species]?.caught ?? 0) === 1) {
        const have = Object.values(S.trainer!.dex).filter((d) => d.caught > 0).length;
        toast(`New species: ${sp.name} (Bestiary ${have} of ${DEX_SPECIES.length})`, 'gold', undefined, 4000);
      }
    } else if (e.k === 'hatch') {
      S.creatures.set(e.creature.id, e.creature);
    } else if (e.k === 'clevel') {
      const c = S.creatures.get(e.id); if (c) { c.level = e.level; modal = true; }
    } else if (e.k === 'revive' && !e.left) {
      toast('Last Revive used · the Merchant sells more', 'err');
    } else if (e.k === 'stopped') {
      toast(`Team knocked out${e.xpLost ? ` · −${e.xpLost.toLocaleString()} XP` : ''} · no potions or Revives, back in Kinhall`, 'err');
    } else if (e.k === 'rest' && e.xpLost) {
      toast(`Team knocked out · −${e.xpLost.toLocaleString()} XP · back in ${Math.round(CONFIG.allFaintedRestMs / 1000)} s`, 'err');
    } else if (e.k === 'retreat') {
      const to = GROUND[e.to];
      toast(`${CONFIG.wipeRetreatCount} knockouts · moved to ${to ? `${AREA[to.area].name} (Lv ${to.level})` : 'an easier hunt'}`, 'err');
    } else if (e.k === 'move') {
      const to = GROUND[e.to];
      toast(`Auto-move → ${to ? `${SPECIES[to.species].name} · ${AREA[to.area].name} (Lv ${to.level})` : 'a better hunt'}`);
    } else if (e.k === 'down' && e.relic) {
      const g = relicGrade(e.relic);
      toast(`A relic dropped: ${relicName(e.relic)}${g ? `, grade ${g}` : ''}`, 'gold');
    } else if (e.k === 'down') {
      for (const d of e.drops) if (d.item.endsWith('token')) toast(`Boss key dropped: ${ITEM[d.item]?.name ?? d.item}`, 'gold');
    }
  }
  if (modal) refreshModal();
}

/** True while this boss's fight and result are on screen: the Bosses page, or the boss's stop on the Trail. */
const bossOnScreen = (boss: string) => S.tab === 'bosses' || trailBossShown(boss);

let updateShown = false;
function newVersion() {
  if (document.hidden) { location.reload(); return; }
  if (updateShown) return;
  updateShown = true;
  const bar = document.createElement('div');
  bar.className = 'update-bar';
  bar.setAttribute('role', 'status');
  bar.innerHTML = '<span>New version</span><button class="btn small gold" type="button">Refresh</button>';
  bar.querySelector('button')!.onclick = () => location.reload();
  document.body.append(bar);
  document.addEventListener('visibilitychange', () => { if (document.hidden) location.reload(); });
}

function start(token: string) {
  app.innerHTML = '';
  mountGame(app);
  mountField(document.getElementById('field') as HTMLCanvasElement);
  startHudClock();
  onCornerChange(() => render(true));
  initStore(() => { if (S.trainer) render(true); });
  let build = '';
  const net = new Net(token, (m) => {
    switch (m.t) {
      case 'build':
        // A deploy happened since this page loaded. A hidden tab reloads at once (nobody is watching); a watched one
        // gets a bar at the top and reloads when the player says so, or the next time the tab is hidden.
        if (build && build !== m.id) newVersion(); else build = m.id;
        break;
      case 'elsewhere': showElsewhere(() => net.send({ t: 'playHere' })); break;
      case 'hello':
        hideElsewhere();
        // falls through
      case 'sync': {
        S.skew = m.now - Date.now();
        S.trainer = m.trainer;
        S.creatures = new Map((m.creatures as CreatureDTO[]).map((c) => [c.id, c]));
        if (S.field?.ground !== m.field.ground) resetBackground();
        S.prevField = null; S.field = m.field; S.fieldAt = performance.now();
        if (m.broadcasts) { S.broadcasts = m.broadcasts; renderFeed(); }
        if (typeof m.online === 'number') S.playersOnline = m.online;
        if (m.t === 'hello') {
          setPassLaunch(m.passLaunch ?? null);
          setEvents(m.events);
          S.founderOpen = !!m.founderOpen;
          S.ranked = !!m.ranked;
          SYNERGY_SWITCH.on = m.synergyOn !== false;
          BOARD_SWITCH.on = m.boardOn !== false;
          // Season one switches (shared/held.ts, shared/trail.ts); battle() reads the held switch, so replays match the server.
          S.heldOn = m.heldOn !== false; HELD_SWITCH.on = S.heldOn;
          S.trailOn = m.trailOn !== false;
          if (S.page === 'trail' || S.page === 'bosses') window.dispatchEvent(new HashChangeEvent('hashchange'));
          awayFromServer(m.away, m.now);
          checkAccountOnHello();
          maybeShowNews((x) => net.send(x));
          localStorage.setItem('mi-admin', m.admin ? '1' : '0');
          setSampleAdmin(!!m.admin);
          // A page opened by its address before the socket was up still needs its data.
          if (S.page === 'market') net.send({ t: 'market' });
          // A new socket is a fresh arrival in Kinhall (the render below sends it).
          kinhallReconnected();
          // The server takes a new socket's tab as on screen, and its corner window as closed.
          if (document.hidden) net.send({ t: 'hidden', on: true });
          if (cornerOpen()) net.send({ t: 'corner', on: true });
          wayfarersReconnected();
          if (S.page === 'admin') net.send({ t: 'admin' });
          if (S.page === 'records' || S.page === 'leaderboards') loadCommunity(S.page, route().sub);
          if (S.page === 'guild') loadGuild();
          if (S.page === 'arena') loadArena();
          if (S.page === 'halls') loadHalls();
          if (S.page === 'worldboss') loadWorldBoss();
          if (S.page === 'plan') loadPlan();
          if (S.page === 'tournaments') loadTournaments();
          // The Social view feeds the Friends link's count on every page.
          if (S.page === 'friends' || S.page === 'player') openSocialRoute(); else net.send({ t: 'social' });
          if (S.page === 'chat') openChatRoute();
        }
        if (m.ff) { S.lastFF = m.ff; dropToasts((s) => s.startsWith('Fast-forwarding ')); if (S.tab === 'admin') net.send({ t: 'admin' }); }
        if (m.boss) {
          // The result waits on the boss's page; nothing switches pages on its own. On that page the fight is about to
          // play on the board, so a toast would only give the ending away (2026-10-26).
          S.boss = m.boss;
          openSection('tlboss', 'boss');
          const name = SPECIES[m.boss.boss]?.name ?? 'The boss';
          if (!bossOnScreen(m.boss.boss)) {
            // The newest toast sits on top, so the first clear goes first and reads under the fight's result.
            const fc = m.boss.firstClear;
            if (fc) toast(`First clear of ${name} on the Trail: ${heldName(fc.item)} (${fc.item.quality}%) and ${fc.diamonds} diamonds.`, 'gold');
            toast(`Boss fight finished: ${m.boss.win ? `${name} defeated` : `${name} was too strong`}`, m.boss.win ? 'gold' : 'err', { label: 'View', run: () => openTab('bosses') });
          }
        }
        if (m.ladder) {
          S.ladder = m.ladder;
          openSection('tlboss', 'ladder');
          // An auto-repeat fight toasts only when the run ends; a single fight always does.
          if (!m.ladder.run && !bossOnScreen(m.ladder.boss)) {
            const name = SPECIES[m.ladder.boss]?.name ?? 'The boss';
            toast(m.ladder.stopped ? `Boss Ladder auto-repeat finished: ${m.ladder.stopped}` : `${name} · Lv ${m.ladder.level.toLocaleString('en-US')} ${m.ladder.win ? 'defeated' : 'held on'}`, m.ladder.win ? 'gold' : 'err',
              { label: 'View', run: () => openTab('bosses') });
          }
        }
        render(true);
        refreshModal();
        break;
      }
      case 'f': {
        S.skew = m.now - Date.now();
        // The whole field now and then, otherwise only what changed (shared/field-patch.ts); one that doesn't fit is
        // skipped until the next whole field.
        const field: FieldDTO | null = m.field ?? (m.fp && S.field ? applyFieldPatch(S.field, m.fp as FieldPatch) : null);
        if (field) {
          if (S.field?.ground !== field.ground) resetBackground();
          S.prevField = S.field; S.field = field; S.fieldAt = performance.now();
        }
        // The whole trainer now and then, otherwise only what changed (shared/trainer-patch.ts).
        if (m.trainer) S.trainer = m.trainer;
        else if (m.tp && S.trainer) S.trainer = applyTrainerPatch(S.trainer, m.tp as TrainerPatch);
        // Creature XP moves every kill; full creature lists only come with a sync.
        if (m.cx) for (const [id, level, xp] of m.cx as [number, number, number][]) { const c = S.creatures.get(id); if (c) { c.level = level; c.xp = xp; } }
        if (m.evs) applyEvents(m.evs);
        scheduleRender();
        break;
      }
      case 'bc':
        S.broadcasts.push(m.b);
        if (S.broadcasts.length > 400) S.broadcasts.splice(0, 100);
        renderFeed();
        if (m.b.loud) showLoud(m.b);
        // Someone else's big catch is a World card only, never an alert over the screen; your own Aura still gets a toast.
        if ((m.b.kind === 'aura' && m.b.who === S.trainer?.name) || m.b.kind === 'legendary') toast(m.b.text, 'gold');
        // A new record is a highlighted feed line only; the Records page refreshes if it is open.
        if ((m.b.kind === 'record' || m.b.record) && S.page === 'records') loadCommunity('records');
        break;
      case 'online': S.playersOnline = m.n; render(); break;
      case 'events': setEvents(m.list); render(); break;
      case 'passLaunch': setPassLaunch(m.day ?? null); render(true); break;
      case 'founder': S.founderOpen = !!m.open; render(true); break;
      case 'ranked': S.ranked = !!m.on; render(true); break;
      case 'synergy': SYNERGY_SWITCH.on = !!m.on; render(true); break;
      case 'board': BOARD_SWITCH.on = !!m.on; render(true); break;
      case 'season1':
        S.heldOn = m.heldOn !== false; HELD_SWITCH.on = S.heldOn; S.trailOn = m.trailOn !== false;
        if (S.page === 'trail' || S.page === 'bosses') window.dispatchEvent(new HashChangeEvent('hashchange'));
        render(true); break;
      case 'trail': onTrailFight(m.fight); break;
      case 'streams': onStreams(m); break;
      case 'kinhall': onKinhall(m); break;
      case 'kinhallEmote': onKinhallEmote(m); break;
      case 'wf': onWayfarers(m); break;
      case 'wfEmote': onWayfarerEmote(m); break;
      case 'market': S.market = m; render(true); break;
      case 'prices': onPrices(m.data); break;
      case 'records': onRecords(m.list); break;
      case 'creatureView': onCreatureView(m); break;
      case 'leaderboards': onBoards(m.data); break;
      case 'guild': onGuildView(m.view); renderFeed(); break;
      case 'guilds': onGuildList(m.list); break;
      case 'guildChanged': onGuildChanged(); break;
      case 'guildWar': onGuildWar(m.data); break;
      case 'guildWarLog': onGuildWarLog(m.data); break;
      case 'guildWarResult': onGuildWarResult(m.text); break;
      case 'arena': onArena(m.data); break;
      case 'arenaResult': onArenaResult(m.match); break;
      case 'arenaMatch': onArenaMatch(m); break;
      case 'arenaPeek': onArenaPeek(m.peek); break;
      case 'halls': onHalls(m.data); break;
      case 'wb': onWb(m.data); break;
      case 'wbResult': onWbResult(m.result, m.data); break;
      case 'hallDuel': onHallDuel(m); break;
      case 'hallResult': onHallResult(m.duel); break;
      case 'hallPractice': onHallPractice(m); break;
      case 'tour': onTour(m.data); break;
      case 'tourMatch': onTourMatch(m.match); break;
      case 'tourGame': onTourGame(m); break;
      case 'social': onSocial(m.data); render(); break;
      case 'profile': onProfile(m); break;
      case 'pmThread': onPmThread(m); break;
      case 'inbox': onInbox(m); break;
      case 'pmNew': onPmNew(m.msg); break;
      case 'socialNote': onSocialNote(m); break;
      case 'friendlyResult': onFriendlyResult(m.match); break;
      case 'friendlyMatch': onFriendlyMatch(m); break;
      case 'training': onTraining(m); break;
      case 'admin': gemPaying.clear(); S.admin = m; localStorage.setItem('mi-admin', '1'); render(true); break;
      case 'admPlayers': onPlayerReport(m.rows); break;
      case 'err': toast(m.msg, 'err'); worldBossErr(); break;
      // Stripe's payout setup page (server/gem-cash.ts); it sends the player back to the Gems tab.
      case 'gemBal': onGemBal(m); render(); break;
      case 'golden': onGolden(m.g ?? null); break;
      case 'gemPayee': if (typeof m.url === 'string' && m.url.startsWith('https://')) location.href = m.url; break;
      case 'toast': if (!purchaseCredited(m.purchase)) toast(m.msg); break;
    }
  });
  net.onAuthFail = () => { localStorage.removeItem('mi-token'); net.close(); authScreen('login'); };
  net.onStatus = (up) => { S.online = up; onConnection(); render(); };
  bindConnection({ retryAt: () => net.retryAt, retryNow: () => net.retryNow() });
  startStatusClock();
  // A tab in the background gets field messages only when something happened (server/world.ts tick).
  document.addEventListener('visibilitychange', () => { net.send({ t: 'hidden', on: document.hidden }); if (!document.hidden) render(true); });
  // With the corner window open the hunt is on screen even while this tab is hidden (Golden Wilds count it).
  onCornerChange((open) => net.send({ t: 'corner', on: open }));
  // A fight's replay ended (or was skipped): the Trail path shows a fresh clear, and a friendly battle's row its winner, only now.
  window.addEventListener('mi-replay-over', () => { if (S.page === 'trail' || S.page === 'friends') scheduleRender(); });
  bindSend((msg) => net.send(msg));
  bindGolden((msg) => net.send(msg));
  void esc;
}

await Promise.all([loadManifest(), loadAuthConfig()]);
watchCreaturePortraits(document.body);
watchArtIcons(document.body);
initSelectPop();
if (!(await handleAuthLinks(app, start, (err) => authScreen('login', err)))) {
  const token = localStorage.getItem('mi-token');
  if (token) start(token); else authScreen();
}
